<template>
    <div
        v-if="is_missing_status"
        class="status-wrapper shaded-light pa-5 pt-4 mb-4 d-flex flex-column align-center"
        :class="border_class"
    >
        <div class="text-center mb-2">
            <v-icon
                :color="icon_color"
                :size="42"
                aria-hidden="true"
            >
                {{ icon_name }}
            </v-icon>

            <div class="font-weight-medium text-h6">
                Brand Registration Status
            </div>

            <div
                class="font-weight-bold text-subtitle-1"
                :class="status_text_class"
            >
                {{ status_text }}
            </div>
        </div>

        <ul class="tracker-details list-style-none pl-0 mt-0 mb-0">
            <li class=text-body-2>
                {{ tcr_step_number != null ? `Step ${tcr_step_number}` : 'This step' }} is required before you can send
                any texts. Carrier approval is outside of our
                control and takes an average of <strong>10 business days</strong>. We recommend
                completing this step as soon as possible to avoid delays in launching your texting
                program.
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'WelcomeCarrierRegistrationStatus',

    props: {
        carrier_registration_status: {
            type: String,
            default: function () { return ''; }
        },

        tcr_step_number: {
            type: Number,
            default: function () { return null; }
        },
    },

    computed: {
        icon_color() {
            switch (this.carrier_registration_status) {
                case 'missing':
                    return 'error'
                case 'pending':
                    return 'info'
                case 'approved':
                    return 'success'
                default:
                    return 'info'
            }
        },

        icon_name() {
            switch (this.carrier_registration_status) {
                case 'missing':
                    return 'mdi-alert-circle-outline'
                case 'pending':
                    return 'mdi-timer-sand'
                case 'approved':
                    return 'mdi-check-circle-outline'
                default:
                    return 'mdi-timer-sand'
            }
        },

        border_class() {
            switch (this.carrier_registration_status) {
                case 'missing':
                    return 'border-error'
                case 'pending':
                    return 'border-info'
                case 'approved':
                    return 'border-success'
                default:
                    return 'border-info'
            }
        },

        status_text_class() {
            switch (this.carrier_registration_status) {
                case 'missing':
                    return 'error--text'
                case 'pending':
                    return 'text-info'
                case 'approved':
                    return 'success--text'
                default:
                    return 'text-info'
            }
        },

        status_text() {
            switch (this.carrier_registration_status) {
                case 'missing':
                    return 'Incomplete - Action Required'
                case 'pending':
                    return 'Submitted - Awaiting Approval'
                case 'approved':
                    return 'Approved'
                default:
                    return 'Submitted - Awaiting Approval'
            }
        },

        is_missing_status() {
            return this.carrier_registration_status === 'missing';
        },

        is_pending_status() {
            return this.carrier_registration_status === 'pending';
        },

        is_approved_status() {
            return this.carrier_registration_status === 'approved';
        }
    }
}
</script>

<style lang="scss" scoped>
.status-wrapper {
    border-left: 0.4rem solid;
}
</style>